export default __webpack_public_path__ + "static/media/HeatBingo.197bc7ec.png";